export const PROJECT_NAME = 'OpenTalent';
export const API_URI = import.meta.env.REACT_APP_GQL_PATH;

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;

export const MAP_API_KEY = import.meta.env.REACT_APP_MAP_API_KEY || '';
export const MAP_API_KEY2 = import.meta.env.REACT_APP_MAP_API_KEY2 || '';
export const CLIENT_ID = import.meta.env.REACT_APP_AUTH0_CLIENT_ID || '';
export const DOMAIN = import.meta.env.REACT_APP_AUTH0_DOMAIN || '';
export const RESPONSE_TYPE = import.meta.env.REACT_APP_AUTH0_RESPONSE_TYPE;
export const AUDIENCE =
  import.meta.env.REACT_APP_AUTH0_AUDIENCE || 'https://opentalent.co';
export const SCOPE = 'openid profile';
export const REDIRECT_URI = `${window.location.origin}/auth0`;
export const STREAM_CHAT_KEY = import.meta.env.REACT_APP_STREAM_CHAT_KEY || '';

export const BACKEND_DOMAIN =
  import.meta.env.REACT_APP_BACKEND_DOMAIN || '';

export const isProdInstance = 'app.opentalent.co' === window.location.host;
